"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowDimensions = exports.getEarliestSupplyStartDate = exports.isCurrentDatePeriod = exports.getRefinedDatePeriod = exports.hasDataForFuelOption = exports.hasTradMeter = exports.hasSmartMeter = exports.getSupplyInfo = exports.generateCombinedUsageForDatePeriod = exports.generateDailyCombinedUsage = exports.generateMonthlyCombinedUsage = exports.generateYearlyCombinedUsage = exports.readIsAboveThreshold = exports.formatReadingDate = exports.updatedQueryParams = exports.nonNegativeConsumption = exports.padGenericMonth = exports.padGenericYear = exports.dateWithMostDays = exports.formatCost = exports.formatKwh = void 0;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var core_1 = require("../../shared/core");
var date_1 = require("../../shared/core/utils/date");
var kapi_meter_reads_1 = require("../kapi-meter-reads");
var formatKwh = function (value) {
    return value == null ? '-' : "".concat(value.toFixed(2).replace('.00', ''), " kWh");
};
exports.formatKwh = formatKwh;
var formatCost = function (value) {
    return value === null ? '-' : (0, core_1.smartMajor2DP)((0, core_1.majorToMinor)(value));
};
exports.formatCost = formatCost;
var dateWithMostDays = function (first, second) {
    var firstDays = (0, date_fns_1.getDaysInMonth)(first);
    var secondDays = (0, date_fns_1.getDaysInMonth)(second);
    return firstDays > secondDays ? first : second;
};
exports.dateWithMostDays = dateWithMostDays;
var padGenericYear = function (data) {
    var monthsInAYear = 12;
    return Array.from(Array(monthsInAYear), function (_, index) {
        var month = index;
        return {
            electricity: (data.electricity &&
                data.electricity.find(function (d) { return (0, date_fns_1.getMonth)(d.date) === month; })) ||
                null,
            gas: (data.gas && data.gas.find(function (d) { return (0, date_fns_1.getMonth)(d.date) === month; })) || null,
        };
    });
};
exports.padGenericYear = padGenericYear;
var padGenericMonth = function (data, date, comparisonDate) {
    var longest = comparisonDate
        ? (0, exports.dateWithMostDays)(date, comparisonDate)
        : date;
    return Array.from(Array((0, date_fns_1.getDaysInMonth)(longest)), function (_, index) {
        var day = index + 1;
        return {
            electricity: (data.electricity &&
                data.electricity.find(function (d) { return (0, date_fns_1.getDate)(d.date) === day; })) ||
                null,
            gas: (data.gas && data.gas.find(function (d) { return (0, date_fns_1.getDate)(d.date) === day; })) || null,
        };
    });
};
exports.padGenericMonth = padGenericMonth;
var nonNegative = function (value) { return (value < 0 ? 0 : value); };
/** Turns chart consumption data non-negative */
var nonNegativeConsumption = function (d) { return (__assign(__assign({}, d), { consumption: nonNegative(d.consumption) })); };
exports.nonNegativeConsumption = nonNegativeConsumption;
/**
 * Updates the name/value pair only, leaving other params as they are.
 */
var updatedQueryParams = function (name, value, search) {
    var urlParams = new URLSearchParams(search);
    urlParams.set(name, value);
    return "?".concat(urlParams.toString());
};
exports.updatedQueryParams = updatedQueryParams;
var isLegacyReading = function (read) {
    return read.readingDateTime !== undefined;
};
var formatReadingDate = function (read) {
    return (0, date_fns_1.format)(isLegacyReading(read) ? read.readingDateTime : read.formattedReadingDate, 'do MMMM yyyy');
};
exports.formatReadingDate = formatReadingDate;
var THRESHOLD_DAYS = 30;
var readIsAboveThreshold = function (read) {
    return (isLegacyReading(read)
        ? new Date(read.readingDateTime)
        : read.formattedReadingDate) < (0, date_fns_1.subDays)(Date.now(), THRESHOLD_DAYS);
};
exports.readIsAboveThreshold = readIsAboveThreshold;
/**
 * Converts the bespoke response for this date period into something consistent
 * we can use for all date periods.
 */
var generateYearlyCombinedUsage = function (data, date, comparisonData, comparisonDate) {
    var paddedUsage = (0, exports.padGenericYear)(data);
    var paddedComparisonUsage = comparisonData
        ? (0, exports.padGenericYear)(comparisonData)
        : null;
    return paddedUsage.map(function (_a, index) {
        var electricity = _a.electricity, gas = _a.gas;
        // The month we are dealing with for this data.
        var rowMonth = index + 1;
        var rowDate = new Date("".concat((0, date_fns_1.getYear)(date), "/").concat(rowMonth, "/01"));
        var current = {
            date: rowDate,
            electricity: electricity || {
                consumption: null,
                cost: null,
                hasData: null,
            },
            gas: gas || {
                consumption: null,
                cost: null,
                hasData: null,
            },
        };
        var comparison;
        if (comparisonDate &&
            paddedComparisonUsage &&
            !(0, date_fns_1.isSameDay)(comparisonDate, date)) {
            // Get the equivalent item from comparison data if there is any.
            var comparisonDataItem = paddedComparisonUsage && paddedComparisonUsage[index];
            var comparisonRowDate = comparisonDate
                ? new Date("".concat((0, date_fns_1.getYear)(comparisonDate), "/").concat(rowMonth, "/01"))
                : null;
            comparison = {
                date: comparisonRowDate,
                electricity: (comparisonDataItem && comparisonDataItem.electricity) || {
                    consumption: null,
                    cost: null,
                    hasData: null,
                },
                gas: (comparisonDataItem && comparisonDataItem.gas) || {
                    consumption: null,
                    cost: null,
                    hasData: null,
                },
            };
        }
        return {
            date: rowDate,
            current: current,
            comparison: comparison,
        };
    });
};
exports.generateYearlyCombinedUsage = generateYearlyCombinedUsage;
/**
 * Converts the bespoke response for this date period into something consistent
 * we can use for all date periods.
 */
var generateMonthlyCombinedUsage = function (data, date, comparisonData, comparisonDate) {
    // Get current usage and "pad" it, ensuring all days have an entry.
    var paddedUsage = (0, exports.padGenericMonth)(data, date, comparisonDate);
    var paddedComparisonUsage = comparisonData
        ? (0, exports.padGenericMonth)(comparisonData, date, comparisonDate)
        : null;
    // Becuase of different length months, we need to know which one has the most
    // days to ensure there is a valid date for the row.
    var mostDays = comparisonDate
        ? (0, exports.dateWithMostDays)(date, comparisonDate)
        : date;
    return paddedUsage.map(function (_a, index) {
        var electricity = _a.electricity, gas = _a.gas;
        // The day of the month we are dealing with for this data.
        var rowDay = index + 1;
        // Create a valid date from the month with the most days.
        var rowDate = new Date("".concat((0, date_fns_1.format)(mostDays, 'yyyy/MM'), "/").concat(rowDay, " UTC"));
        // Date for current data if it exists (different length months).
        var currentRowDate = rowDay > (0, date_fns_1.getDaysInMonth)(date)
            ? null
            : new Date("".concat((0, date_fns_1.format)(date, 'yyyy/MM'), "/").concat(rowDay, " UTC")) || null;
        var current = {
            date: currentRowDate,
            electricity: electricity || {
                consumption: null,
                cost: null,
                hasData: null,
            },
            gas: gas || {
                consumption: null,
                cost: null,
                hasData: null,
            },
        };
        var comparison;
        if (paddedComparisonUsage &&
            comparisonDate &&
            !(0, date_fns_1.isSameDay)(comparisonDate, date)) {
            // Get the equivalent item from comparison data if there is any.
            var comparisonDataItem = paddedComparisonUsage && paddedComparisonUsage[index];
            // Date for comparison data if it exists (different length months).
            var comparisonRowDate = rowDay > (0, date_fns_1.getDaysInMonth)(comparisonDate)
                ? null
                : new Date("".concat((0, date_fns_1.format)(comparisonDate, 'yyyy/MM'), "/").concat(rowDay, " UTC"));
            comparison = {
                date: comparisonRowDate,
                electricity: (comparisonDataItem && comparisonDataItem.electricity) || {
                    consumption: null,
                    cost: null,
                    hasData: null,
                },
                gas: (comparisonDataItem && comparisonDataItem.gas) || {
                    consumption: null,
                    cost: null,
                    hasData: null,
                },
            };
        }
        return { date: rowDate, current: current, comparison: comparison };
    });
};
exports.generateMonthlyCombinedUsage = generateMonthlyCombinedUsage;
/**
 * Converts the bespoke response for this date period into something consistent
 * we can use for all date periods.
 */
var generateDailyCombinedUsage = function (data, date) {
    var halfHours = (0, date_1.createHalfHoursforDay)(date);
    var emptyConsumption = { consumption: null, cost: null, hasData: null };
    var findMatchingHalfHour = function (fuelUsage, halfHour) {
        return (fuelUsage && fuelUsage.find(function (_a) {
            var date = _a.date;
            return (0, date_fns_1.isEqual)(date, halfHour);
        })) || __assign(__assign({}, emptyConsumption), { date: halfHour });
    };
    return halfHours.map(function (halfHour) { return ({
        date: halfHour,
        current: {
            date: halfHour,
            electricity: findMatchingHalfHour(data.electricity, halfHour),
            gas: findMatchingHalfHour(data.gas, halfHour),
        },
    }); });
};
exports.generateDailyCombinedUsage = generateDailyCombinedUsage;
var generateCombinedUsageForDatePeriod = function (datePeriod, data, date, comparisonData, comparisonDate) {
    switch (datePeriod) {
        case 'daily':
            return (0, exports.generateDailyCombinedUsage)(data, date);
        case 'monthly':
            return (0, exports.generateMonthlyCombinedUsage)(data, date, comparisonData, comparisonDate);
        default:
            return (0, exports.generateYearlyCombinedUsage)(data, date, comparisonData, comparisonDate);
    }
};
exports.generateCombinedUsageForDatePeriod = generateCombinedUsageForDatePeriod;
var getSupplyInfo = function (supplyPoints) {
    var elecSupply = supplyPoints.electricity[0];
    var gasSupply = supplyPoints.gas[0];
    return {
        electricity: elecSupply
            ? {
                type: (elecSupply === null || elecSupply === void 0 ? void 0 : elecSupply.states.isSmart) ? 'smart' : 'traditional',
                start: new Date(elecSupply === null || elecSupply === void 0 ? void 0 : elecSupply.startDate),
                latestRead: (0, kapi_meter_reads_1.getLatestActualReading)(elecSupply.readings),
                multipleActiveSuppliesForFuel: supplyPoints.electricity.length > 1,
            }
            : null,
        gas: gasSupply
            ? {
                type: (gasSupply === null || gasSupply === void 0 ? void 0 : gasSupply.states.isSmart) ? 'smart' : 'traditional',
                start: new Date(gasSupply === null || gasSupply === void 0 ? void 0 : gasSupply.startDate),
                latestRead: (0, kapi_meter_reads_1.getLatestActualReading)(gasSupply.readings),
                multipleActiveSuppliesForFuel: supplyPoints.gas.length > 1,
            }
            : null,
    };
};
exports.getSupplyInfo = getSupplyInfo;
var hasSmartMeter = function (_a) {
    var electricity = _a.electricity, gas = _a.gas;
    return (electricity && electricity.type === 'smart') ||
        (gas && gas.type === 'smart');
};
exports.hasSmartMeter = hasSmartMeter;
var hasTradMeter = function (_a) {
    var electricity = _a.electricity, gas = _a.gas;
    return (electricity && electricity.type === 'traditional') ||
        (gas && gas.type === 'traditional');
};
exports.hasTradMeter = hasTradMeter;
var hasDataForFuelOption = function (_a, fuel) {
    var electricity = _a.electricity, gas = _a.gas;
    switch (fuel) {
        case 'both':
            return (electricity && electricity.hasData) || (gas && gas.hasData);
        case 'electricity':
            return electricity && electricity.hasData;
        case 'gas':
            return gas && gas.hasData;
    }
};
exports.hasDataForFuelOption = hasDataForFuelOption;
var getRefinedDatePeriod = function (datePeriod) {
    return datePeriod === 'yearly' ? 'monthly' : 'daily';
};
exports.getRefinedDatePeriod = getRefinedDatePeriod;
var isCurrentDatePeriod = function (date, datePeriod) {
    switch (datePeriod) {
        case 'daily':
            return (0, date_fns_1.isToday)(date);
        case 'monthly':
            return (0, date_fns_1.isThisMonth)(date);
        case 'yearly':
            return (0, date_fns_1.isThisYear)(date);
    }
};
exports.isCurrentDatePeriod = isCurrentDatePeriod;
var getEarliestSupplyStartDate = function (_a) {
    var electricity = _a.electricity, gas = _a.gas;
    if (electricity && gas) {
        return (0, date_fns_1.isBefore)(electricity.start, gas.start)
            ? electricity.start
            : gas.start;
    }
    else if (electricity) {
        return electricity.start;
    }
    else if (gas) {
        return gas.start;
    }
};
exports.getEarliestSupplyStartDate = getEarliestSupplyStartDate;
function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
}
function useWindowDimensions() {
    var _a = __read((0, react_1.useState)(getWindowDimensions()), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
}
exports.useWindowDimensions = useWindowDimensions;
